import _sortBy from 'lodash/sortBy';
import { makeEntityScaffold } from '@classpass/saga-tools';
import URLS from 'constants/urls';
import { transformV2ClientResponse, renameKeys } from 'helpers/core';

function decorateTags(tag, level = 1, rootTagId) {
  const decoratedTag = {
    ...tag,
    level,
  };

  if (level > 1) {
    decoratedTag.rootTagId = rootTagId;
  }

  if (tag.subtags) {
    decoratedTag.subtags = tag.subtags
      .map(subtag => decorateTags(subtag, level + 1, rootTagId || tag.id))
      .sort((tagA, tagB) => (tagA.name > tagB.name ? 1 : -1));
  }

  return decoratedTag;
}

const handler = ({ httpClient }) =>
  httpClient
    .get(URLS.class.tags({ excludeOutdoors: true }))
    .then(transformV2ClientResponse)
    .then(data => renameKeys(data, { subTags: 'subtags' }))
    .then(res => {
      const ret = _sortBy(
        Object.values(res).map(tag => decorateTags(tag)),
        'name'
      );
      return ret;
    });

export default makeEntityScaffold('ACTIVITY_TAG_TREE', handler);
